import React, { useState } from "react";
import usePost from "Hooks/usePost";
// import { createLogClient } from "API/swesum";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import SystemTable from "Pages/AdminInterface/system/components/SystemTable";
import LogForm from "./LogForm";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export default function Logs({ entityID, logs, users, call, checkbox }) {
  const [logsState, setLogsState] = useState(logs);
  const { openSuccess, openError } = usePopupNotificationContext();

  const createLogClientReq = usePost({
    mtnFunc: (body) => call(body),
    onError: (data) => {
      openError("Ett fel uppstod när loggmeddelandet skapades");
    },
    onSuccess: (data) => {
      openSuccess("Loggmeddelandet har skapats", 3000);
      setLogsState([data, ...logsState]);
    },
  });

  return (
    <>
      <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <LogForm
          handlePost={(logObj) => createLogClientReq.post(logObj)}
          entityID={entityID}
          checkboxInfo={checkbox}
          logs={logsState}
        />
        <Grid item md={12}>
          <SystemTable logs={logsState} users={users} />
        </Grid>
      </Grid>
    </>
  );
}
